import "./App.css";
// import useWindowDimensions from './hooks/useWindowDimension';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./assets/scss/themes.scss";

import Index from "./pages/Landing/OnePage";
import Login from "./pages/Authentication/Login";
import KakaoPage from "./pages/Authentication/KakaoPage";
import NaverPage from "./pages/Authentication/NaverPage";
import ReservationPage from "./pages/Reservation";
import Detail from "./pages/Detail";
import EventProductReception from "./pages/EventProduct/Reception/index";
import MyPage from "./pages/UserPage/MyPage";
import Purchases from "./pages/UserPage/Purchases";
import Notices from "./pages/Notice/NoticeList/index";
import NoticeDetail from "./pages/Notice/NoticeDetail";
import NoticeForm from "./pages/Notice/NoticeForm";
import CampMap from "./pages/CampMap/CampMap";
import OrderPage from "./pages/Order/OrderPage";
import OrderDone from "./pages/Order/OrderPage/OrderDone";
import Ticket from "./pages/Ticket/Ticket";
import AddReserve from "./pages/Reservation/AddReserve";
import AddTicket from "./pages/Ticket/AddTicket";
import SecretLogin from "./pages/Authentication/SecretLogin";
import AddOptionsDetail from "./pages/Detail/AddOptionsDetail";
import AddOptionsOrder from "./pages/Order/AddOptions";
import AddOptionsOrderDone from "./pages/Order/AddOptions/OrderDone";
import CancelOptionsDetail from "./pages/Detail/CancelOptionsDetail";
import InquiryList from "./pages/Inquiry/List";
import InquiryDetail from "./pages/Inquiry/Detail";
import InquiryForm from "./pages/Inquiry/Form";
import OrderTicketMultiPage from "./pages/Order/OrderTicketMultiPage";
import MultiOrderDone from "./pages/Order/OrderTicketMultiPage/MultiOrderDone";

import PhoneLogin from "./pages/Authentication/PhoneLogin";
import { useUserStore } from "./store/store";
import React, { useEffect, useState } from "react";
import { API, BACKEND_HOST } from "./api";
import AppDownload from "./pages/AppDownload";
import { SITE_ID } from "./assets/meta/meta";
import ShopList from "./pages/Shop/ShopList";
import OrderShopping from "./pages/Order/OrderShopping";
import ShoppingDetail from "./pages/Shop/ShoppingDetail";
import ApplyCampUlsan from "./pages/Events/ApplyCampUlsan";
import { QueryClient, QueryClientProvider } from "react-query";
import EventVoucherPage from "./pages/Events/Voucher";
import ShoppingPurchaseList from "./pages/UserPage/purchaseList/ShoppingPurchaseList";
import ReservationList from "./pages/UserPage/purchaseList/ReservationList";
import TicketPurchaseList from "./pages/UserPage/purchaseList/TicketPurchaseList";
import UserVoucher from "./pages/UserPage/purchaseList/UserVoucher";
import CouponBook from "./pages/UserPage/purchaseList/CouponBook";
import GiftSendTabView from "./pages/UserPage/purchaseList/GiftSendTabView";
import GiftTabView from "./pages/UserPage/purchaseList/GiftTabView";
import CancelList from "./pages/UserPage/purchaseList/CancelList";
import B2BTabView from "./pages/UserPage/B2BCoupon/B2BTabView";
import NotFoundPage from "./NotFoundPage";
import { KAKAO_JS_KEY, getAccessToken } from "./api/auth";
import AmazingPassPage from "./pages/Events/AmazingPass";
import AmazingPassPurchaseList from "./pages/UserPage/purchaseList/AmazingPassPurchaseList";
import GiftMain from "./pages/Gift";
import GiftReservationPage from "./pages/Gift/Reservation";
import GiftTicketPage from "./pages/Gift/Ticket";
import GiftVoucherPage from "./pages/Gift/Voucher";
import GiftCouponPage from "./pages/Gift/Coupon";
import PromotionB2BCouponPage from "./pages/Promotion/b2bCoupon";
import B2BInfo from "./pages/UserPage/B2BCoupon/B2BInfo";
import B2BPreCouponTabView from "./pages/UserPage/B2BPreCoupon/B2BPreCouponTabView";
import B2BPreCouponInfo from "./pages/UserPage/B2BPreCoupon/B2BPreCouponInfo";
import B2BVoucherTabView from "./pages/UserPage/B2BVoucher/B2BVoucherTabView";
import B2BVoucherInfo from "./pages/UserPage/B2BVoucher/B2BVoucherInfo";
import PromotionB2BPrecouponPage from "./pages/Promotion/B2BPrecoupon";
import PromotionB2BVoucherPage from "./pages/Promotion/B2BVoucher";
const { Kakao } = window;

const queryClient = new QueryClient();

function App() {
  const [isWebPurchase, setIsWebPurchase] = useUserStore((state) => [state.isWebPurchase, state.setIsWebPurchase]);
  const [isManaged, setIsManaged] = useUserStore((state) => [state.isManaged, state.setIsManaged]);
  const [isWebPurchaseTicket, setIsWebPurchaseTicket, setIsWebShopping] = useUserStore((state) => [state.isWebPurchaseTicket, state.setIsWebPurchaseTicket, state.setIsWebShopping]);
  const [site, setSite] = useUserStore((state) => [state.site, state.setSite]);
  const [user, setUser] = useUserStore((state) => [state.user, state.setUser]);
  const [availableSites, setAvailableSites] = useUserStore((state) => [state.availableSites, state.setAvailableSites]);
  const accessToken = getAccessToken();

  useEffect(() => {
    API.get(`/sites/camps/${SITE_ID}/`)
      .then((response) => {
        const data = response.data;
        setSite(data);
        setIsWebPurchase(data.is_web_purchase);
        setIsWebPurchaseTicket(data.is_web_purchase_ticket);
        setIsWebShopping(data.is_web_shopping);
        setIsManaged(data.is_managed);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await API(`/sites/get_sites_app/`);
        const data = res.data;
        const filterSites = data.result.sites.filter((site) => site.open_state === "confirm" || site.open_state === "open");
        // console.log("set site:", filterSites);
        setAvailableSites(filterSites);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    Kakao.cleanup();
    Kakao.init(KAKAO_JS_KEY);
    console.log(Kakao.isInitialized());
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route path="/" element={<Index isWebPurchase={isWebPurchase} isWebPurchaseTicket={isWebPurchaseTicket} isManaged={isManaged} />} />
          <Route path="/login" element={<Login />} />
          <Route path="/phone-login" element={<PhoneLogin />} />
          <Route path="/admin-login" element={<SecretLogin />} />
          <Route path="/kakao" element={<KakaoPage />} />
          <Route path="/naver" element={<NaverPage />} />

          <Route path="/detail/:type/:id" element={<Detail />} />
          <Route path="/reception/:type" element={<EventProductReception />} />

          {accessToken ? (
            <>
              <Route path="/my-page" element={<MyPage />} />

              <Route path="/my-page/shopping-purchase" element={<ShoppingPurchaseList />} />
              <Route path="/my-page/reservation" element={<ReservationList />} />
              <Route path="/my-page/ticket" element={<TicketPurchaseList />} />
              <Route path="/my-page/voucher" element={<UserVoucher />} />
              <Route path="/my-page/amazingpass" element={<AmazingPassPurchaseList />} />
              <Route path="/my-page/coupon" element={<CouponBook />} />
              <Route path="/my-page/gift-send" element={<GiftSendTabView />} />
              <Route path="/my-page/gift-box" element={<GiftTabView />} />
              <Route path="/my-page/cancel" element={<CancelList />} />

              <Route path="/my-page/b2b/coupon" element={<B2BTabView />} />
              <Route path="/my-page/b2b-info/coupon" element={<B2BInfo />} />
              <Route path="/my-page/b2b/precoupon" element={<B2BPreCouponTabView />} />
              <Route path="/my-page/b2b-info/precoupon" element={<B2BPreCouponInfo />} />
              <Route path="/my-page/b2b/voucher" element={<B2BVoucherTabView />} />
              <Route path="/my-page/b2b-info/voucher" element={<B2BVoucherInfo />} />

              <Route path="/my-page/gift-box" element={<MyPage tabparam="gift-box" />} />
              <Route path="/mypage/gift-box" element={<MyPage tabparam="gift-box" />} />
            </>
          ) : (
            <>
              <Route path="/my-page" element={<Navigate to="/login" replace={true} />} />
              <Route path="/my-page/*" element={<Navigate to="/login" replace={true} />} />
            </>
          )}

          <Route path="/purchases" element={<Purchases />} />
          <Route path="/notice" element={<Notices />} />
          <Route path="/notice/detail/:id" element={<NoticeDetail />} />
          <Route path="/notice/form/:id" element={<NoticeForm />} />

          <Route path="/inquiry" element={<InquiryList />} />

          <Route path="/inquiry/detail/:id" element={<InquiryDetail />} />
          <Route path="/inquiry/form/:id" element={<InquiryForm />} />

          <Route path="/camp-map" element={<CampMap />} />
          <Route path="/order" element={<OrderPage />} />

          <Route path="/order-ticket-multi" element={<OrderTicketMultiPage />} />
          <Route path="/order-done-multi/:orderId" element={<MultiOrderDone />} />

          <Route path="/order-done/:orderId" element={<OrderDone />} />
          <Route path="/add-reserve" element={<AddReserve />} />
          <Route path="/add-ticket" element={<AddTicket />} />

          <Route path="/add-options-detail/:id" element={<AddOptionsDetail />} />
          <Route path="/add-options-order" element={<AddOptionsOrder />} />
          <Route path="/add-options-order-done/:orderId" element={<AddOptionsOrderDone />} />
          <Route path="/cancel-options-detail/:id" element={<CancelOptionsDetail />} />

          <Route path="/shop" element={<ShopList />} />
          <Route path="/shop/:id" element={<ShoppingDetail />} />
          <Route path="/order-shop" element={<OrderShopping />} />

          <Route path="/apply/camp-ulsan-free-voucher-2023-12" element={<ApplyCampUlsan />} />

          <Route path="/reservation" element={<ReservationPage />} />
          <Route path="/ticket" element={<Ticket />} />
          <Route path="/app-download" element={<AppDownload path="ticket" />} />

          <Route path="/event-voucher/:id" element={<EventVoucherPage />} />
          <Route path="/event-amazingpass" element={<AmazingPassPage />} />

          <Route path="/gift" element={<GiftMain />} />
          <Route path="/gift/reservation/:id" element={<GiftReservationPage />} />
          <Route path="/gift/ticket/:id" element={<GiftTicketPage />} />
          <Route path="/gift/voucher/:id" element={<GiftVoucherPage />} />
          <Route path="/gift/coupon/:id" element={<GiftCouponPage />} />

          <Route path="/promotion/coupon/:share_pin_code" element={<PromotionB2BCouponPage />} />
          <Route path="/promotion/voucher/:share_pin_code" element={<PromotionB2BVoucherPage />} />
          <Route path="/promotion/precoupon/:share_pin_code" element={<PromotionB2BPrecouponPage />} />
          

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
